import { Component, OnInit, Injector } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { ProgramStyleService } from '../../../mesc.service';
import { ProgramStyle } from '../../../../../shared/model';
import { MaintenanceService } from "../maintenance.service";

@Component({
  selector: 'program-style',
  templateUrl: './program-style.component.html',
  styleUrls: ['./program-style.component.css']
})
export class ProgramStyleComponent implements OnInit {
  private readonly maintenanceService: MaintenanceService;

  constructor(
    private ProgramStyleService: ProgramStyleService,
    private readonly injector: Injector,

  ) { 
    this.maintenanceService = injector.get(MaintenanceService);
    this.maintenanceService.getCurrentPageValue();
  }

  isNew: boolean = false;
  editDataItem: ProgramStyle;
  editForm = new FormGroup({
    ProgramStyleDescripton: new FormControl("", Validators.required),
    Id: new FormControl(),
    CreatedDate: new FormControl(),
    CreatedBy: new FormControl(),
    ModifiedDate: new FormControl(),
    ModifiedBy: new FormControl(),
  });

  columns: any[] = [
    {
      field: "ProgramStyleDescripton",
      title: "Description",
    }
  ];

  onRead = () => {
    return this.ProgramStyleService.read('', true);
  }

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
    },
    columns: this.columns,
    read: this.onRead,
    service: this.ProgramStyleService,
    fileName: 'programStyle.xlsx'
  }

  formDialog = {
    title: "Program Style",
    formControls: [
      {
        type: "text",
        name: "ProgramStyleDescripton",
        title: "Description*",
        readonly: "never",
      },
    ]
  }

  ngOnInit(): void {
    this.ProgramStyleService.query();
  }

  setModelHandler() {
    this.editDataItem = new ProgramStyle();
  }
}